module.exports = __webpack_public_path__ + "i18n/ko.6b29e39a290a75fd20ef18eea2642e42.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ko.json
// module id = 1311
// module chunks = 59